/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { css } from 'styled-components';
import { generatePatternStyles } from '@web-stories-wp/patterns';

/**
 * Internal dependencies
 */
import {
  DEFAULT_GRADIENT_FALLBACK_COLOR,
  getGradientFallbackColor,
} from '../../utils/textGradient';

export const getGradientTextStyles = (
  gradientFill,
  {
    includeCaretColor = false,
    backgroundSize = null,
    backgroundPosition = null,
  } = {}
) => {
  if (!gradientFill) {
    return null;
  }

  const fallbackColor =
    getGradientFallbackColor(gradientFill) || DEFAULT_GRADIENT_FALLBACK_COLOR;

  return css`
    ${generatePatternStyles(gradientFill, 'background')}
    ${backgroundSize ? `background-size: ${backgroundSize};` : ''}
    ${backgroundPosition
      ? `background-position: ${backgroundPosition};`
      : ''}
    ${backgroundSize || backgroundPosition
      ? 'background-repeat: no-repeat;'
      : ''}
    background-clip: text;
    -webkit-background-clip: text;
    ${includeCaretColor ? `caret-color: ${fallbackColor};` : ''}
    color: ${fallbackColor};
    -webkit-text-fill-color: transparent;
  `;
};
